import React from 'react';
import { Stack } from '@mui/material';
import { Form } from 'mobx-react-form';
import { observer } from 'mobx-react-lite';
import { wrapForm, FormOptions } from 'components/shared/form';
import { plugins } from 'forms/utils/formPlugins';
import { formOptions } from 'forms/utils/formOptions';
import { OperatingExpenses } from './OperatingExpenses';
import { operatingExpenseFormFields } from './operatingExpenseFormConfig';

const formConfig: FormOptions = {
  fields: operatingExpenseFormFields,
  options: {
    ...formOptions,
    validateOnChange: true,
  },
  plugins,
};

type OperatingExpensesProps = {
  form: Form;
};

const OperatingExpensesContainer = observer(({ form }: OperatingExpensesProps) => {
  return (
    <Stack spacing={3}>
      <OperatingExpenses form={form} />
    </Stack>
  );
});

export default wrapForm(formConfig)(OperatingExpensesContainer);
